import script from "./SaveBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveBtn.vue?vue&type=script&setup=true&lang=js"

import "./SaveBtn.vue?vue&type=style&index=0&id=df072728&lang=scss"

const __exports__ = script;

export default __exports__